"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SwipeOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M6.42,9.71l-1-1H9.5a1,1,0,0,0,0-2H5.41l1-1A1,1,0,0,0,5,4.29L2.29,7a.93.93,0,0,0-.21.33,1,1,0,0,0,0,.76,1.15,1.15,0,0,0,.21.33L5,11.12a1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3A1,1,0,0,0,6.42,9.71Z"/><path d="M29.92,8.09a1,1,0,0,0,0-.76A.93.93,0,0,0,29.71,7L27,4.29a1,1,0,0,0-1.42,1.42l1,1H22.5a1,1,0,1,0,0,2h4.09l-1,1a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l2.71-2.7A1.15,1.15,0,0,0,29.92,8.09Z"/><path d="M25.59,14.47l-6.13-.78V8.53a3.46,3.46,0,1,0-6.91,0V19.25c-1-.45-1.79-.82-1.94-.88a3.45,3.45,0,0,0-3.92,1.19A3.39,3.39,0,0,0,6,22.12,3.45,3.45,0,0,0,7.38,24.4l6.55,4.91A3.46,3.46,0,0,0,16,30h9.57a2.64,2.64,0,0,0,2.62-2.31l1.06-8.45A4.3,4.3,0,0,0,25.59,14.47ZM27.27,19l-1.05,8.45a.65.65,0,0,1-.64.56H16a1.47,1.47,0,0,1-.88-.29L8.58,22.79A1.46,1.46,0,0,1,8,21.84a1.48,1.48,0,0,1,.28-1.08,1.45,1.45,0,0,1,1.17-.59,1.6,1.6,0,0,1,.47.08c.2.08,1.8.82,3.2,1.47l1.42.66V8.53a1.46,1.46,0,1,1,2.91,0v6.93l7.86,1A2.27,2.27,0,0,1,27.27,19Z"/>';
var SwipeOutlineSVG = function SwipeOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.SwipeOutlineSVG = SwipeOutlineSVG;
SwipeOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SwipeOutlineSVG);
exports.default = _default;